import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ListGroup, Modal, Button,
} from 'react-bootstrap';

// import openInNewTab from '../../utils/helpers/openNewTab.helper';
import './DoxyContainer.css';
import openInNewTab from '../../utils/helpers/openNewTab.helper';

const DoxyContainer = ({ isComplete }) => {
  const [showIncompleteModal, setShowIncompleteModal] = useState(false);
  const [showInvalidHours, setShowInvalidHours] = useState(false);
  const [showDoxyInstructions, setShowDoxyInstructions] = useState(false);

  const toggleIncompleteModal = () => {
    const state = !showIncompleteModal;
    setShowIncompleteModal(state);
  };

  // eslint-disable-next-line no-unused-vars
  const toggleInvalidHoursModal = () => {
    const state = !showInvalidHours;
    setShowInvalidHours(state);
  };

  const toggleShowDoxyInstructions = () => {
    const state = !showDoxyInstructions;
    setShowDoxyInstructions(state);
  };

  const navigateToDoxy = () => {
    openInNewTab('https://monarchnc.doxy.me/registration');
  };

  const handleClick = () => {
    // eslint-disable-next-line new-cap
    const d = new Date();
    const offset = -4;
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const estDate = new Date(utc + (offset * 3600000));
    const hour = estDate.getHours();
    const day = estDate.getDay();

    if (!isComplete) {
      toggleIncompleteModal();
    } else if (hour < 8 || hour > 15 || day === 0 || day === 6) {
      toggleInvalidHoursModal();
    } else {
      toggleShowDoxyInstructions();
    }
  };

  return (

    <ListGroup className="bootstrap-override" style={{ marginTop: '10px' }}>
      <ListGroup.Item
        action
        className="bootstrap-override"
        variant={isComplete ? 'success' : 'secondary'}
        onClick={handleClick}
      >
        Finish Registration
      </ListGroup.Item>

      <Modal centered show={showIncompleteModal} onHide={toggleIncompleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          All forms have not been completed for registration.
          Please go back and finish the remaining forms.
          If you need assistance with the forms, you may continue
          to the waiting room for a staff to assist you.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={navigateToDoxy} variant="secondary">Proceed to Waiting Room</Button>
          <Button onClick={toggleIncompleteModal} variant="primary">Return to Assessment </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered show={showInvalidHours} onHide={toggleInvalidHoursModal}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Our registration process is closed for the day.  Our registration hours are Monday –
          Friday from 8 AM to 3 PM EST. You may finish the registration process
          by returning to this link during our registration hours.
          Thank you for your time.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={toggleInvalidHoursModal} variant="secondary">Close </Button>
        </Modal.Footer>
      </Modal>
      <Modal centered show={showDoxyInstructions} onHide={toggleShowDoxyInstructions}>
        <Modal.Header closeButton />
        <Modal.Body>
          You will now be sent to the virtual waiting room. Please do the following when prompted:
          <br />
          <br />
          <ul>
            <li>
              Enter your first and last name
              <br />
              <strong>*Parents/Guardians: </strong>
              Enter the name of your child
            </li>
            <br />
            <li>Give access to your camera and microphone</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={navigateToDoxy} variant="primary">Proceed to Waiting Room </Button>
        </Modal.Footer>
      </Modal>
    </ListGroup>

  );
};

export default DoxyContainer;

DoxyContainer.propTypes = {
  isComplete: PropTypes.bool.isRequired,
};
